(function () {
  'use strict';

  // Carousel
  document.addEventListener('DOMContentLoaded', function () {
    var prevBtn = document.querySelector('.Pdp-Alumni-Chevron-Container.prev');
    var nextBtn = document.querySelector('.Pdp-Alumni-Chevron-Container.next');
    var cards = document.querySelectorAll('.Pdp-Alumni-Card');

    var currentIndex = 0;
    var maxVisible;

    if (window.innerWidth >= 320 && window.innerWidth <= 767) {
      maxVisible = 1;
    } else if (window.innerWidth >= 767 && window.innerWidth <= 1023) {
      maxVisible = 2;
    } else {
      maxVisible = 3;
    }

    // Hide the Arrow Container when there are 3 cards visible,
    // since we only have 3 alumni
    if (maxVisible == 3) {
      document.querySelector('.Pdp-Alumni-Arrow-Wrapper').style.display = 'none';
    } else {
      document.querySelector('.Pdp-Alumni-Arrow-Wrapper').style.display = 'flex';
    }

    // Show the first maxVisible cards
    for (var i = 0; i < maxVisible && i < cards.length; i++) {
      cards[i].style.display = 'flex';
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) {
        cards[currentIndex + maxVisible - 1].style.display = 'none';
        currentIndex--;
        cards[currentIndex].style.display = 'flex';
      }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < cards.length - maxVisible) {
        cards[currentIndex].style.display = 'none';
        currentIndex++;
        cards[currentIndex + maxVisible - 1].style.display = 'flex';
      }
    });
  });

  // Responsive
  function updateResponsiveAlumni() {
    var screenWidth = window.innerWidth;

    // ...............
    // MOBILE.........
    // ...............

    if (screenWidth >= 320 && screenWidth <= 767) {
      var pdpAlumniDescriptions = document.querySelectorAll('.Pdp-Alumni-Card-Textbox > p');
      pdpAlumniDescriptions.forEach(function (description) {
        description.classList.remove('text-body-m');
        description.classList.add('text-body-s');
      });
    }

    // ................
    // TABLET..........
    // ................

    if (screenWidth >= 768 && screenWidth <= 1023) {
      var pdpAlumniDescriptions = document.querySelectorAll('.Pdp-Alumni-Card-Textbox > p');
      pdpAlumniDescriptions.forEach(function (description) {
        description.classList.add('text-body-m');
        description.classList.remove('text-body-s');
      });
    }

    // ................
    // LAPTOP..........
    // ................

    if (screenWidth >= 1024 && screenWidth <= 1439) {
      var pdpAlumniDescriptions = document.querySelectorAll('.Pdp-Alumni-Card-Textbox > p');
      pdpAlumniDescriptions.forEach(function (description) {
        description.classList.add('text-body-m');
        description.classList.remove('text-body-s');
      });
    }

    // ...............
    // DESKTOP........
    // ...............

    if (screenWidth >= 1439) {
      var pdpAlumniDescriptions = document.querySelectorAll('.Pdp-Alumni-Card-Textbox > p');
      pdpAlumniDescriptions.forEach(function (description) {
        description.classList.add('text-body-m');
        description.classList.remove('text-body-s');
      });
    }
  }

  updateResponsiveAlumni();
  window.addEventListener('resize', updateResponsiveAlumni);
})();
